import React, { Fragment } from 'react'
import data from '../lifeStages.json';
import HeroSection from '../components/common/HeroSection';
import ImageCardGrid from '../components/common/WhyImageCard';
import NotSureSection from '../components/LifeStages/NotSureSection';
import { CardWithImage } from '../components/Programs/OutComesSection';
import CTASection from '../components/LifeStages/CTASection';
import DigitalHealthFAB from '../components/Digitalhealth';
const { slides } = data.sections.hero;
const LifeStages = () => {
    return (
        <Fragment>
            <DigitalHealthFAB/>
            <HeroSection slides={slides} />
            <div className="max-w-4xl mx-auto">
                <ImageCardGrid data={data.whyCare} colsProp={3} />
            </div>
            <NotSureSection data={data.notSureSection} />
            <ImageCardGrid data={data.thoughtFulCare} />
            <div className="max-w-6xl mx-auto">
                <ImageCardGrid data={data.careDesigned} />
            </div>
            <CTASection item={data.cta} />
        </Fragment>
    )
}

export default LifeStages